export const DIGIDOO_ONLINE_PRESENTATION_URL = 'https://calendly.com/moritz-hiebl-digidoo/digidoo-kennenlernen';

export const DIGIDOO_SOCIAL_MEDIA_LINKS = [
  {
    key: 'instagram',
    url: 'https://www.instagram.com/digidoo.app',
    iconPath: '/assets/social/instagram.svg',
  },
  {
    key: 'facebook',
    url: 'https://facebook.com/people/Digidoo/61578490075112/',
    iconPath: '/assets/social/facebook.svg',
  },
  {
    key: 'whatsapp',
    url: 'https://chat.whatsapp.com/G16ytutDhASKZFfVgQ70pk',
    iconPath: '/assets/social/whatsapp.svg',
  },
];

export type DigidooSocialMediaKey = (typeof DIGIDOO_SOCIAL_MEDIA_LINKS)[number]['key'];
